import React, { TableHTMLAttributes } from 'react';
import styles from './AGCollapsibleTable.module.css';

const IndentedTR: React.FC<TableHTMLAttributes<HTMLTableRowElement>> = ({ children }) => {
    return <tr className={styles.indentedRow}>{children}</tr>;
};

export default IndentedTR;
